import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import dayjs from 'dayjs';

@Pipe({
  name: 'liveStreamDate'
})
export class LiveStreamDatePipe implements PipeTransform {

  constructor(private translateService: TranslateService) {}

  transform(value: Date | string): string {
    const date = dayjs(value);
    const isToday = date.isSame(dayjs(), 'day');

    if (isToday) {
      const today = this.translateService.instant('times.today');
      return `${today} ${date.format('HH:mm')}`;
    }

    return date.format('D MMMM YYYY HH:mm');
  }

}
